import React from 'react'
import {
    Grid,
    Button,
    Box,
    FormControl,
    Select,
    MenuItem,
    Typography,
} from '@mui/material'
import { faSearch } from '@fortawesome/pro-duotone-svg-icons/faSearch'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DefaultGrid from '@/feature/Grid/DefaultGrid'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'

import { faChevronDoubleDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDoubleDown'
import { faChevronDoubleUp } from '@fortawesome/pro-duotone-svg-icons/faChevronDoubleUp'
import { inputPaperVariant } from '@/Components/Elements/StyledComponents/Input/inputVariants'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

class SearchDefDossier extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            advancedSearch: this.props.advancedSearch
                ? this.props.advancedSearch
                : false,
            items: this.props.items,
            showArchive: this.props.showArchive,
            resetSearch: false,
            archived: null,
            dossierQuery: this.props.dossierQuery
                ? this.props.dossierQuery
                : null,
            search: this.props.search ? this.props.search : [],
            availableDropdowArchivable: null,
        }

        this.handleAdvancedSearch = this.handleAdvancedSearch.bind(this)
        this.handleReset = this.handleReset.bind(this)
        this.updateSearchValue = this.updateSearchValue.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
        this.fetchDossierSettingsArchive =
            this.fetchDossierSettingsArchive.bind(this)
    }

    isAllowed(credential) {
        if (
            this.props.kedo.user().isSuperAdmin() ||
            this.props.kedo.env().isEnvironmentAdmin()
        ) {
            return true
        }
        return this.props.kedo
            .env()
            .isAllowedDefDossier(credential, this.props.defDossier.id)
    }

    handleAdvancedSearch() {
        this.setState((state) => ({
            advancedSearch: !state.advancedSearch,
        }))
    }

    onKeyPress(item, event) {
        if (event.key === 'Enter' && this.props.doSearch) {
            this.saveSearchParams(this.state.search, this.state.dossierQuery)
            this.props.doSearch(this.state.search, this.state.dossierQuery)
        }
    }

    updateSearchValue(itemId, value) {
        let utils = this.props.kedo.utils()
        let search = this.state.search
        search = search.filter((searchItem) => itemId !== searchItem.id)

        if (value && utils.getCustomlength(value) > 0) {
            search.push({
                id: itemId,
                value: value,
            })
        }

        this.setState({ search: search })
    }

    renderSearchItems() {
        return (
            <Box component="form" id={`${this.props.defDossierId}-search`}>
                <DefaultGrid
                    changeValue={this.updateSearchValue}
                    content={this.state.search}
                    errors={{}}
                    kedo={this.props.kedo}
                    onChange={this.props.onChange}
                    onKeyPress={this.onKeyPress}
                    items={this.state.items
                        .filter((item) => item.view === 'search')
                        .sort((a, b) => {
                            return a.col - b.col
                        })}
                    mode={'search'}
                    reset={this.state.resetSearch}
                />
            </Box>
        )
    }

    renderAdvancedSearchItems() {
        if (!this.state.advancedSearch) {
            return
        }

        return (
            <Box
                component="form"
                id={`${this.props.defDossierId}-advanced-search`}
            >
                <DefaultGrid
                    changeValue={this.updateSearchValue}
                    content={this.state.search}
                    errors={{}}
                    kedo={this.props.kedo}
                    onChange={this.props.onChange}
                    onKeyPress={this.onKeyPress}
                    items={this.state.items
                        .filter((item) => item.view === 'advanced-search')
                        .sort((a, b) => {
                            return a.col - b.col
                        })}
                    mode={'advanced-search'}
                    reset={this.state.resetSearch}
                />
            </Box>
        )
    }

    translateQuery(query) {
        if (!query || !query.translations || query.translations.length <= 0) {
            return query.uuid
        }

        let culture = this.props.kedo.env().getSelectedLocale()
        let trans = query.translations.find(
            (item) => item.culture === culture.code
        )
        if (trans) {
            return trans.search_name
        }

        return query.translations[0].search_name
    }

    renderDossierQueries() {
        if (!this.props.defDossier || !this.props.defDossier.dossierqueries) {
            return ''
        }
        let culture = this.props.kedo.env().getSelectedLocale()

        return (
            <FormControl fullWidth size="small">
                <Typography
                    component={'h6'}
                    sx={{ fontWeight: 700, fontSize: '1rem', mb: '10px' }}
                >
                    {this.props.kedo.t('Search in')}
                </Typography>
                <Select
                    value={
                        this.state.dossierQuery || this.props.defDossier.uuid
                    }
                    onChange={(e) => {
                        this.setState({ dossierQuery: e.target.value })

                        //Redirect if the url has a dossierQuery set
                        var url = new URL(window.location)
                        if (url.searchParams.has('dossierQuery')) {
                            if (e.target.value.length > 0) {
                                url.searchParams.delete('dossierQuery')
                            } else {
                                url.searchParams.set(
                                    'dossierQuery',
                                    e.target.value
                                )
                            }

                            url.search = url.searchParams
                            url = url.toString()
                            history.replaceState({}, null, url)
                        }
                    }}
                    name={'dossierquery'}
                    size="small"
                >
                    <MenuItem value={this.props.defDossier.uuid}>
                        {this.props.kedo.t('Everything')}
                    </MenuItem>
                    {this.props.defDossier.dossierqueries
                        .filter((query) => {
                            if (query.translations?.length > 0) {
                                let trans = query.translations.find(
                                    (item) => item.culture === culture.code
                                )
                                if (trans?.search_name?.length > 0) {
                                    return query
                                }
                            }
                        })
                        .map((query) => (
                            <MenuItem key={query.uuid} value={query.uuid}>
                                {this.translateQuery(query)}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        )
    }

    saveSearchParams(search, dossierQuery, archived) {
        const utils = this.props.kedo.utils()

        const searchItems = {
            defDossierId: this.props.defDossierId,
            advancedSearch: this.state.advancedSearch,
        }

        if (search && search.length > 0) searchItems.search = search

        if (dossierQuery && dossierQuery.length > 0)
            searchItems.dossierQuery = dossierQuery

        if (archived && archived.length > 0) searchItems.archived = archived

        if (searchItems.search || searchItems.dossierQuery || search.archived) {
            utils.createSavedSearch(searchItems)
        } else {
            utils.deleteSavedSearch(this.props.defDossierId)
        }
    }

    handleReset() {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)
        if (params.has('dossierQuery')) {
            params.delete('dossierQuery')
            const newUrl =
                params.toString().length > 0
                    ? `${url.pathname}?${params}`
                    : url.pathname
            window.history.replaceState({}, '', newUrl)
        }

        this.setState({ search: [], resetSearch: true })
        const searchForm = document.getElementById(
            `${this.props.defDossierId}-search`
        )
        if (searchForm && typeof searchForm.reset === 'function') {
            searchForm.reset()
        }

        const advSearch = document.getElementById(
            `${this.props.defDossierId}-advanced-search`
        )
        //Check if there is a advanced search
        if (advSearch && typeof advSearch.reset === 'function') {
            advSearch.reset()
        }
        //Force the form to be reloaded and re-rendered
        this.setState(
            {
                dossierQuery: null,
                search: [],
                content: [],
                loading: true,
                advancedSearch: false,
            },
            () =>
                setTimeout(() => {
                    this.setState({ loading: false })
                    this.saveSearchParams([])
                    this.props.doSearch(
                        this.state.search,
                        this.state.dossierQuery,
                        this.state.archived
                    )
                }, 100)
        )
    }

    async fetchDossierSettingsArchive() {
        if (
            this.props.kedo.user().isSuperAdmin() ||
            this.props.kedo.env().isEnvironmentAdmin()
        ) {
            this.setState({ availableDropdowArchivable: true })
            return
        }
        const rolSettings = this.props.kedo.env().getCurrentEnvironmentRoles()
        let defdosssierSettings
        try {
            defdosssierSettings = await this.props.kedo
                .api()
                .get(
                    this.props.kedo
                        .api()
                        .getDefDossierEndpoint(this.props.defDossier.id)
                )
        } catch {
            this.setState({ availableDropdowArchivable: false })
            return
        }

        const hiddenArchivableRoles =
            defdosssierSettings.data?.settings?.show_archivable_roles

        if (!Array.isArray(hiddenArchivableRoles)) {
            this.setState({ availableDropdowArchivable: true })
            return
        }

        const userRoleIds = rolSettings.map((rol) => rol.id?.toString())
        const hiddenRoleIds = new Set(
            hiddenArchivableRoles.map((roleId) => roleId?.toString())
        )
        const availableDropdowArchivable = !userRoleIds.some((roleId) =>
            hiddenRoleIds.has(roleId)
        )

        this.setState({ availableDropdowArchivable })
    }

    componentDidMount() {
        this.fetchDossierSettingsArchive()
    }

    render() {
        let advancedSearchItems = this.state.items.filter(
            (item) => item.view === 'advanced-search'
        )
        const kedo = this.props.kedo

        return (
            <Grid
                container
                size={12}
                sx={inputPaperVariant}
                className={'searchBlock'}
            >
                {this.state.loading ? (
                    <Grid size={12}>
                        <LoadingDefault />
                    </Grid>
                ) : (
                    <Grid size={12}>
                        <Box component={'form'}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid
                                    size={1}
                                    sx={{ margin: 'auto', maxWidth: '2%' }}
                                >
                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        size={'lg'}
                                    />
                                </Grid>
                                <Grid size={11} sx={{ minWidth: '96%' }}>
                                    {this.state.showArchive === true &&
                                        this.state
                                            .availableDropdowArchivable ===
                                            true && (
                                            <Grid
                                                size={12}
                                                container
                                                justifyContent="flex-end"
                                            >
                                                <FormControl>
                                                    <Select
                                                        name="archived"
                                                        onChange={(e) => {
                                                            this.setState(
                                                                {
                                                                    [e.target
                                                                        .name]:
                                                                        e.target
                                                                            .value,
                                                                },
                                                                () => {
                                                                    this.saveSearchParams(
                                                                        this
                                                                            .state
                                                                            .search,
                                                                        this
                                                                            .state
                                                                            .dossierQuery,
                                                                        this
                                                                            .state
                                                                            .archived
                                                                    )
                                                                    this.props.doSearch(
                                                                        this
                                                                            .state
                                                                            .search,
                                                                        this
                                                                            .state
                                                                            .dossierQuery,
                                                                        this
                                                                            .state
                                                                            .archived
                                                                    )
                                                                }
                                                            )
                                                        }}
                                                        size="small"
                                                        displayEmpty
                                                        native
                                                    >
                                                        <optgroup
                                                            label={kedo.t(
                                                                'Archive'
                                                            )}
                                                        >
                                                            <option value="">
                                                                {kedo.t(
                                                                    'Not archived'
                                                                )}
                                                            </option>
                                                            <option value="both">
                                                                {kedo.t('Both')}
                                                            </option>
                                                            <option value="archived">
                                                                {kedo.t(
                                                                    'Only archived'
                                                                )}
                                                            </option>
                                                        </optgroup>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                    {this.renderDossierQueries()}
                                    {this.renderSearchItems()}
                                    {this.state.advancedSearch ? (
                                        <hr
                                            className="hr-text"
                                            data-content={kedo.t(
                                                'Advanced search'
                                            )}
                                        />
                                    ) : null}
                                    {this.renderAdvancedSearchItems()}
                                    <br />
                                    <Grid size={12} container spacing={2}>
                                        <Grid
                                            size={{
                                                xs: '12',
                                                lg:
                                                    advancedSearchItems?.length <=
                                                    0
                                                        ? 12
                                                        : 6,
                                            }}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                gap: 1,
                                            }}
                                        >
                                            <StyledButton
                                                onClick={() => {
                                                    this.props.doSearch(
                                                        this.state.search,
                                                        this.state.dossierQuery,
                                                        this.state.archived
                                                    )
                                                    this.saveSearchParams(
                                                        this.state.search,
                                                        this.state.dossierQuery,
                                                        this.state.archived
                                                    )
                                                }}
                                                sx={{
                                                    '& svg': {
                                                        mr: 1,
                                                    },
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faSearch}
                                                />
                                                {kedo.t('Search')}
                                            </StyledButton>
                                            <Button
                                                variant={'text'}
                                                onClick={() =>
                                                    this.handleReset()
                                                }
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '1rem',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {kedo.t('Reset')}
                                            </Button>
                                        </Grid>
                                        {advancedSearchItems.length > 0 ? (
                                            <Grid
                                                size={{ xs: '12', lg: '6' }}
                                                sx={{
                                                    display: 'flex',
                                                    flexGrow: 1,
                                                    justifyContent: 'flex-end',
                                                }}
                                            >
                                                <span>
                                                    <StyledButton
                                                        variant={'outlined'}
                                                        color="secondary"
                                                        invert
                                                        onClick={
                                                            this
                                                                .handleAdvancedSearch
                                                        }
                                                        sx={{
                                                            '& svg': {
                                                                mr: 1,
                                                            },
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={
                                                                !this.state
                                                                    .advancedSearch
                                                                    ? faChevronDoubleDown
                                                                    : faChevronDoubleUp
                                                            }
                                                        />
                                                        {kedo.t(
                                                            'Advanced search'
                                                        )}{' '}
                                                    </StyledButton>
                                                </span>
                                            </Grid>
                                        ) : null}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                )}
            </Grid>
        )
    }
}

export default SearchDefDossier
